import axios from 'axios';
import { HTTPHeaders } from '@/globals/enums';
import { STORAGE_KEYS } from '@/constants/storage';
import StorageService from '@/services/StorageService';
import { authService } from '@/services/auth.service';
import { refreshArobaToken } from '../aroba.service';

const request = axios.create({
  headers: {
    'X-Client-Version': process.env.VUE_APP_AROBA_API_X_Client_Version,
  },
});

let isRefreshing = false;
let refreshSubscribers = [];
request.interceptors.request.use(
  async function (config) {
    if (!navigator.onLine) {
      // if offline reject request
      return Promise.reject(new Error('No internet connection'));
    }
    const token = StorageService.getItem(STORAGE_KEYS.SCMCognitoToken);
    if (token) {
      config.headers[HTTPHeaders.XArobaViewUserToken] = token.accessToken;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    const { config, response } = err;
    const originalRequest = config;
    if (response && response.status === 401) {
      if (!isRefreshing) {
        isRefreshing = true;
        refreshArobaToken().then((accessToken) => {
          isRefreshing = false;
          onRefreshed(accessToken);
          refreshSubscribers = [];
        });
      }
      const retryOrigReq = new Promise((resolve) => {
        subscribeTokenRefresh(() => {
          authService.getAuthHeaders().then((authHeaders) => {
            originalRequest.headers = {
              ...originalRequest.headers,
              [HTTPHeaders.XArobaViewUserToken]:
                authHeaders[[HTTPHeaders.XArobaViewUserToken]],
            };
            resolve(axios(originalRequest));
          });
        });
      });
      return retryOrigReq;
    }
    return Promise.reject(err);
  }
);

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function onRefreshed(token) {
  refreshSubscribers.map((cb) => cb(token));
}
export default request;
